import React, { useState, useEffect } from "react";
import styles from "./Slider.module.css";
import i18next from "i18next";

const Slider = () => {
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [isRTL, setIsRTL] = useState(false);

	// Array of image URLs
	const images = [
		"/assets/images/slide01.png",
		"/assets/images/slide02.png",
		"/assets/images/slide03.png",
		"/assets/images/slide04.png",
		"/assets/images/slide05.png",
		"/assets/images/slide06.png",
		"/assets/images/slide07.png",
	];

	useEffect(() => {
		// Function to update the image index every 7 seconds
		const interval = setInterval(() => {
			setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
		}, 6000);

		// Clean up function to clear the interval when component unmounts
		return () => clearInterval(interval);
	}, [images.length]); // Re-run effect when the number of images changes

	useEffect(() => {
		// Detect language directionality using i18next
		const detectLanguageDirection = () => {
			const languageDirection = i18next.dir();
			setIsRTL(languageDirection === "rtl");
		};

		detectLanguageDirection();

		// Listen for language change events
		i18next.on("languageChanged", detectLanguageDirection);

		// Clean up function to remove event listener
		return () => {
			i18next.off("languageChanged", detectLanguageDirection);
		};
	}, []);

	return (
		<div className={styles.slider}>
			<div
				className={styles.imageContainer}
				style={{
                    transform: isRTL ? `translateX(${currentImageIndex * 100}%)` : `translateX(-${currentImageIndex * 100}%)`,
                }}>
				{images.map((image, index) => (
					<img
						key={index}
						src={image}
						alt={`Slide ${index + 1}`}
						className={styles.image}
					/>
				))}
			</div>
		</div>
	);
};

export default Slider;
